function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import StringBuffer from '../../../../java/lang/StringBuffer';
import Location from '../geom/Location';
import Position from './Position';
var TopologyLocation = /*#__PURE__*/function () {
  function TopologyLocation() {
    _classCallCheck(this, TopologyLocation);
    TopologyLocation.constructor_.apply(this, arguments);
  }
  return _createClass(TopologyLocation, [{
    key: "setAllLocations",
    value: function setAllLocations(locValue) {
      for (var i = 0; i < this.location.length; i++) {
        this.location[i] = locValue;
      }
    }
  }, {
    key: "isNull",
    value: function isNull() {
      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] !== Location.NONE) return false;
      }
      return true;
    }
  }, {
    key: "setAllLocationsIfNull",
    value: function setAllLocationsIfNull(locValue) {
      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] === Location.NONE) this.location[i] = locValue;
      }
    }
  }, {
    key: "isLine",
    value: function isLine() {
      return this.location.length === 1;
    }
  }, {
    key: "merge",
    value: function merge(gl) {
      if (gl.location.length > this.location.length) {
        var newLoc = new Array(3).fill(null);
        newLoc[Position.ON] = this.location[Position.ON];
        newLoc[Position.LEFT] = Location.NONE;
        newLoc[Position.RIGHT] = Location.NONE;
        this.location = newLoc;
      }
      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] === Location.NONE && i < gl.location.length) this.location[i] = gl.location[i];
      }
    }
  }, {
    key: "getLocations",
    value: function getLocations() {
      return this.location;
    }
  }, {
    key: "flip",
    value: function flip() {
      if (this.location.length <= 1) return null;
      var temp = this.location[Position.LEFT];
      this.location[Position.LEFT] = this.location[Position.RIGHT];
      this.location[Position.RIGHT] = temp;
    }
  }, {
    key: "toString",
    value: function toString() {
      var buf = new StringBuffer();
      if (this.location.length > 1) buf.append(Location.toLocationSymbol(this.location[Position.LEFT]));
      buf.append(Location.toLocationSymbol(this.location[Position.ON]));
      if (this.location.length > 1) buf.append(Location.toLocationSymbol(this.location[Position.RIGHT]));
      return buf.toString();
    }
  }, {
    key: "setLocations",
    value: function setLocations(on, left, right) {
      this.location[Position.ON] = on;
      this.location[Position.LEFT] = left;
      this.location[Position.RIGHT] = right;
    }
  }, {
    key: "get",
    value: function get(posIndex) {
      if (posIndex < this.location.length) return this.location[posIndex];
      return Location.NONE;
    }
  }, {
    key: "isArea",
    value: function isArea() {
      return this.location.length > 1;
    }
  }, {
    key: "isAnyNull",
    value: function isAnyNull() {
      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] === Location.NONE) return true;
      }
      return false;
    }
  }, {
    key: "setLocation",
    value: function setLocation() {
      if (arguments.length === 1) {
        var locValue = arguments[0];
        this.setLocation(Position.ON, locValue);
      } else if (arguments.length === 2) {
        var locIndex = arguments[0];
        var _locValue = arguments[1];
        this.location[locIndex] = _locValue;
      }
    }
  }, {
    key: "init",
    value: function init(size) {
      this.location = new Array(size).fill(null);
      this.setAllLocations(Location.NONE);
    }
  }, {
    key: "isEqualOnSide",
    value: function isEqualOnSide(le, locIndex) {
      return this.location[locIndex] === le.location[locIndex];
    }
  }, {
    key: "allPositionsEqual",
    value: function allPositionsEqual(loc) {
      for (var i = 0; i < this.location.length; i++) {
        if (this.location[i] !== loc) return false;
      }
      return true;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return TopologyLocation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { TopologyLocation as default };
TopologyLocation.constructor_ = function () {
  this.location = null;
  if (arguments.length === 1) {
    if (arguments[0] instanceof Array) {
      var location = arguments[0];
      this.init(location.length);
    } else if (Number.isInteger(arguments[0])) {
      var on = arguments[0];
      this.init(1);
      this.location[Position.ON] = on;
    } else if (arguments[0] instanceof TopologyLocation) {
      var gl = arguments[0];
      this.init(gl.location.length);
      if (gl !== null) {
        for (var i = 0; i < this.location.length; i++) {
          this.location[i] = gl.location[i];
        }
      }
    }
  } else if (arguments.length === 3) {
    var _on = arguments[0];
    var left = arguments[1];
    var right = arguments[2];
    this.init(3);
    this.location[Position.ON] = _on;
    this.location[Position.LEFT] = left;
    this.location[Position.RIGHT] = right;
  }
};